var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.719,
    height: 21.719,
    viewBox: "0 0 21.719 21.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M480.445,216.272a1.277,1.277,0,1,0,1.277,1.277A1.277,1.277,0,0,0,480.445,216.272Zm-5.676,1.637a5.364,5.364,0,1,0,5.364,5.364A5.37,5.37,0,0,0,474.768,217.91Zm0,8.8a3.436,3.436,0,1,1,3.436-3.436A3.44,3.44,0,0,1,474.768,226.709Zm10.823-7.894a6.542,6.542,0,0,0-6.543-6.542h-8.634a6.542,6.542,0,0,0-6.542,6.542v8.635a6.542,6.542,0,0,0,6.542,6.542h8.634a6.542,6.542,0,0,0,6.543-6.542Zm-2.049,8.635a4.493,4.493,0,0,1-4.493,4.493h-8.634a4.493,4.493,0,0,1-4.493-4.493v-8.635a4.493,4.493,0,0,1,4.493-4.493h8.634a4.493,4.493,0,0,1,4.493,4.493Z",
    transform: "translate(-463.872 -212.274)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaWhite);
export default __webpack_public_path__ + "static/media/insta-white.e31f96cebd0ed394a437b91d14f9494a.svg";
export { ForwardRef as ReactComponent };